export const OTP_TYPES = {
  CONTACT_PHONE: 'CONTACT',
  PORTABILITY_PHONE: 'POSSESSION',
};

export const OTP_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
};
